import alasql from 'alasql';

export function teamsList(data, team_type_id) {
  let result = alasql(`
    SEARCH / AS @club
      teams / AS @team
      RETURN (
        @club->id AS [KlubbId],
        @club->club_name AS [KlubbNavn],
        @club->active_reg AS [active_reg],
        @team->name AS [GruppeNavn],
        @team->id AS [GruppeId],
        @team->team_category_name AS [GruppeKategori],
        @team->team_type_id AS [GrupperingsTypeId],
        @team->team_type_name AS [GrupperingsType],
        @team->members_count AS [AntallMedlemmer]
      )
    FROM ?
  `, [data]);
  result = alasql(`
    SELECT
      KlubbId,
      KlubbNavn,
      active_reg,
      CASE
        WHEN active_reg=true THEN 'Påmeldt'
        WHEN active_reg=false THEN 'Ikke Påmeldt'
      END AS AktivPaamelding,
      GruppeNavn,
      GruppeId,
      GruppeKategori,
      GrupperingsTypeId,
      GrupperingsType,
      CAST(AntallMedlemmer AS NUMBER) AS AntallMedlemmer
    FROM ?
    WHERE GrupperingsTypeId = ?
  `, [result, team_type_id]);
  return result;
}

export function teamMembersList(data, team_type_id) {
  let result = alasql(`
    SEARCH / AS @club
      teams / AS @team
      members / AS @member
      EX(includeEmptyArray(categories)) / AS @category
      RETURN (
        @club->id AS [KlubbId],
        @club->club_name AS [KlubbNavn],
        @club->active_reg AS [active_reg],
        @team->name AS [GruppeNavn],
        @team->id AS [GruppeId],
        @team->team_category_name AS [GruppeKategori],
        @team->team_type_id AS [GrupperingsTypeId],
        @team->team_type_name AS [GrupperingsType],
        @member->id AS [LagMedlemsId],
        @member->member_id AS [MedlemsId],
        @member->first_name AS [Fornavn],
        @member->last_name AS [Etternavn],
        @member->birth_date AS [Fodselsdag],
        @category->name AS  [Kategorinavn]
      )
    FROM ?
  `, [data]);
  result = alasql(`
    SELECT
      KlubbId,
      KlubbNavn,
      active_reg,
      CASE
        WHEN active_reg=true THEN 'Påmeldt'
        WHEN active_reg=false THEN 'Ikke Påmeldt'
      END AS AktivPaamelding,
      GruppeNavn,
      GruppeId,
      GruppeKategori,
      GrupperingsTypeId,
      GrupperingsType,
      LagMedlemsId,
      MedlemsId,
      (Fornavn + " " + Etternavn) AS [MedlemsNavn],
      Fornavn,
      Etternavn,
      Fodselsdag,
      CONCAT_STRINGS(Kategorinavn) AS MedlemsKategorier
    FROM ?
    WHERE GrupperingsTypeId = ?
    GROUP BY
      KlubbId,
      KlubbNavn,
      active_reg,
      GruppeNavn,
      GruppeId,
      GruppeKategori,
      GrupperingsTypeId,
      GrupperingsType,
      LagMedlemsId,
      MedlemsId,
      Fornavn,
      Etternavn,
      Fodselsdag,
      MedlemsNavn
  `, [result, team_type_id]);
  // console.log(data, result, _.filter(result, (item) => {
  // 	return item.Kategorinavn.includes(",") && !item.Kategorinavn.includes("helg");
  // }));
  return result;
}

export function crossTeamReport(mainTeam, secondTeam) {
  return alasql(`
    SELECT mainTeam.*,
      secondTeam.GruppeNavn as KryssGruppeNavn,
      secondTeam.GruppeKategori as KryssGruppeKategori,
      secondTeam.MedlemsKategorier as KryssMedlemsKategorier
    FROM ? as mainTeam
    LEFT JOIN ? as secondTeam on mainTeam.MedlemsId = secondTeam.MedlemsId
  `, [mainTeam, secondTeam]);
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/teams.js
 **/